<app-header></app-header>
<section class="reportsList">
  <div class="container-fluid">
    <div class="initiale_sestion">
      <div class="head">
        <h4>{{'Manage DTS reports'| translate}}</h4>
        <!-- <div *ngIf="accountDetails.cnss_url && accountDetails.cnss_url != null" class="head-container"> -->
        <div  class="head-container">
          <!-- <div class="dts-add-bulk-pdf-div">
            <a href="{{accountDetails.cnamgs_url}}" target="_blank" *ngIf="accountDetails.cnamgs_url && accountDetails.cnamgs_url != null">
              <div class="pdf-container">
                <div class="pdf_icon"><img src="assets/images/cnamgspdf.png"></div>
              </div>
            </a>
            <div class="pdf-container" *ngIf="accountDetails.cnss_url && accountDetails.cnss_url != null"> 
              <div (click)="openDoc()" class="pdf_icon"><img src="assets/images/cnsspdf.png"></div>
            </div>
          </div> -->
          <div class="dts-add-bulk-btn-div">
            <button *ngIf="dtsreportList && dtsreportList?.length >= 1 || reportStatus !='5' && dtsreportList && dtsreportList.length >= 1" id="submit_btn4" class="btn btn-main2 pulse" (click)="gotoUrl(1)">{{'Initiate a declaration' | translate}}</button>
            <button *ngIf="dtsreportList && dtsreportList?.length >= 1 || reportStatus !='5' && dtsreportList && dtsreportList.length >= 1" id="submit_btn3" class="btn btn-main2 pulse btn-green" (click)="gotoUrl(2)">{{'DTS Bulk Upload' | translate}}</button>
          </div>
        </div>
      </div>
      <div class="legend">
        <!-- <div id="pending">
          <div class="circle"> </div>
          <h4 class="legend_txt">{{'Waiting for Approval'| translate}}</h4>
        </div> -->
        <div id="paynow">
          <div class="circle"> </div>
          <h4 class="legend_txt">{{'Waiting for payment'| translate}}</h4>
        </div>
        <!-- <div id="rejected">
          <div class="circle"> </div>
          <h4 class="legend_txt">{{'Report Rejected'| translate}}</h4>
        </div> -->
        <div id="completed">
          <div class="circle"> </div>
          <h4 class="legend_txt">{{'Payment Completed'| translate}}</h4>
        </div>
      </div>
      <div class="legend">
        <div>
          <label>{{'Filter by'| translate}}</label>
          <select [(ngModel)]="reportStatus" (change)="onFilterChange()">
            <!-- <option value="1">{{ 'Pending' | translate}}</option> -->
            <!-- <option value="2">{{ 'Rejected' | translate}}</option> -->
            <option value="3">{{ 'Pay Now' | translate}}</option>
            <option value="4">{{ 'Completed' | translate}}</option>
            <option value="5" selected>{{ 'All' | translate}}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-4">
    <div class="container-fluid reports_status mt-4 mb-5">
      <div class="card-grid {{item.type}}" *ngFor="let item of dtsreportList">
        <div class="child1">
          <div class="dflex">
            <div class="status {{item.type}}">
              <h6>{{ item.status_type | translate}} <i *ngIf="item.status == 1" class="fa-solid fa-check"></i></h6>
            </div>
            <div class="columns">
              <h3 class="sub-title">{{ 'DTS du' | translate}} {{ item.quarter_label }}</h3>
              <h6 class="sm_text">{{'Employer Name'| translate}} : <span>{{ item.employer_name }}</span></h6>
              <h6 class="sm_text">{{'CNSS Employer ID'| translate}} : <span>{{item.employer_cnss_id || '--'}}</span></h6>
              <h6 class="sm_text">{{'CNAMGS Employer ID'| translate}} : <span>{{item.employer_cnamgs_id || '--'}}</span></h6>
            </div>
          </div>
        </div>
        <div class="child2">
          <div class="columns">
            <h6 class="sm_text">{{'No of Employees'| translate}} : <span>{{ item.employee_count }}</span></h6>
            <h6 class="sm_text">{{'Company name'| translate}} : <span>{{ item.company_name }}</span></h6>
            <h6 class="sm_text">{{'Email'| translate}} : <span>{{ item.email }}</span></h6>
          </div>
        </div>
        <div class="child3">
          <div class="columns">
            <h6 class="sm_text">{{'Post box'| translate}} : <span>{{ item.fax }}</span></h6>
            <h6 class="sm_text">{{'Phone'| translate}} : <span>+241 {{ item.telephone }}</span></h6>
            <h6 class="sm_text">{{'Submit Date'| translate}} : <span>{{ item.submit_date }}</span></h6>
          </div>
        </div>
        <div class="child4 position-relative paid-status-div-container">
          <!-- [routerLink]="['/report-view', 'pendingcnss']" -->
           <div class="paid-status-div" *ngIf="item.cnss_status == 1 || item.cnamgs_status == 1">
            <h6 class="sm_text" *ngIf="item.cnss_status == 1">{{'CNSS Paid'| translate}} : <i  class="fa-solid fa-check"></i></h6>
            <h6 class="sm_text not-paid" *ngIf="item.cnss_status != 1">{{'CNSS Pending'| translate}} : <i  class="fa-solid fa-xmark"></i></h6>
            <h6 class="sm_text" *ngIf="item.cnamgs_status == 1">{{'CNAMGS Paid'| translate}} : <i  class="fa-solid fa-check"></i></h6>
            <h6 class="sm_text not-paid" *ngIf="item.cnamgs_status != 1">{{'CNAMGS Pending'| translate}} : <i  class="fa-solid fa-xmark"></i></h6>
           </div>
          <button *ngIf="item.status != 6" id="submit_btn" class="btn btn-main2" (click)="getViewofReports(item.cnss_uuid, item.cnamgs_uuid, item.status)"><a>{{'View'| translate}} <br> {{'Details'| translate}}</a></button>
          <button *ngIf="item.status == 6" id="submit_btn" class="btn btn-main2" (click)="getViewofReports(item.cnss_uuid, item.cnamgs_uuid, item.status)"><a *ngIf="item.cnss_status != 1 && item.cnamgs_status != 1">{{'Pay Now1'| translate}} </a><a *ngIf="item.cnss_status != 1 && item.cnamgs_status == 1" >{{'Pay CNSS'| translate}} </a><a *ngIf="item.cnss_status == 1 && item.cnamgs_status != 1" >{{'Pay CNAMGS'| translate}} </a></button>
        </div>
      </div>
    </div>
  </div>
  <div class="middle-section getstarted" *ngIf="dtsreportList && dtsreportList.length == 0 && accountDetails.cnamgs == 1 && accountDetails.cnss == 1">
    <div class="image-container reportsIMain text-center">
      <img src="assets/images/cnss_pic_remove_logo.png" class="img-fluid">
      <h3 *ngIf="reportStatus == 5 && dtsreportList && dtsreportList.length == 0" class="text"> {{"You haven't initiate any"| translate}}<br> {{'DTS reports yet.'| translate}}</h3>
      <h3 *ngIf="reportStatus != 5 && dtsreportList && dtsreportList.length == 0" class="text"> {{"No result found"| translate}}</h3>
      <button id="submit_btn" class="btn btn-main2 pulse mt-3" (click)="gotoUrl(1)">{{'Initiate a declaration' | translate}}</button>
      <button id="submit_btn2" class="btn btn-main2 pulse mt-3" (click)="gotoUrl(2)">{{'DTS Bulk Upload' | translate}}</button>
    </div>
  </div>
  <ng-container *ngIf=" accountDetails.cnamgs != 1 || accountDetails.cnss != 1">
    <app-onboarding-portal></app-onboarding-portal>
  </ng-container>
  <div class="modal fade" id="successModal" data-backdrop="true" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" data-backdrop="static">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <div class="parent">
            <!-- <div class="cnsslogo">
              <img src="assets/images/logoWithText1.png" class="img-fluid">
              <p>CAISSE NATIONALE<br>DE SECURITE SOCIALE</p>
            </div> -->
            <div class="image-container">
              <img src="assets/images/Link-sucsess.png">
            </div>
            <div class="text-container text-center" *ngIf="reportData && reportData.data && reportData.data.quarter">
              <h4 class="modal-header-txt">{{'Congratulations! We acknowledge receipt of your DTS'| translate}} {{ reportData.data.quarter }}</h4>
              <p class="para-light">{{'We will study your declaration and get back to you to enable you to make payment.' | translate}}</p>
              <button id="submit_btn" class="btn btn-medium" data-dismiss="modal">{{'OK'| translate}}</button>
            </div>
            <div class="text-container text-center" *ngIf="reSubmitData && reSubmitData.quarter">
              <h4 class="modal-header-txt">{{'Congratulations! We acknowledge receipt of your DTS'| translate}} {{ reSubmitData.quarter }}</h4>
              <p class="para-light">{{'We will study your declaration and get back to you to enable you to make payment.' | translate}}</p>
              <button id="submit_btn" class="btn btn-medium" data-dismiss="modal">{{'OK'| translate}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="paymentSuccess" data-backdrop="true" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" data-backdrop="static">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <div class="parent">
            <!-- <div class="cnsslogo">
              <img src="assets/images/logoWithText1.png" class="img-fluid">
              <p>CAISSE NATIONALE<br>DE SECURITE SOCIALE</p>
            </div> -->
            <div class="image-container">
              <img src="assets/images/Link-sucsess.png">
            </div>
            <div class="text-container text-center">
              <h4 class="modal-header-txt">{{'Congratulations! The Payment is Successfully Completed'| translate}}</h4>
              <button id="submit_btn" class="btn btn-medium" data-dismiss="modal">{{'OK'| translate}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<app-add-bank></app-add-bank>
<app-footer></app-footer>
<app-contact-floating></app-contact-floating>
